var render = function () {
  var _vm$walletData, _vm$walletData$user, _vm$walletData2, _vm$walletData2$user, _vm$walletData3, _vm$walletData3$user, _vm$walletData4, _vm$walletData4$user, _vm$walletData5, _vm$walletData5$user, _vm$walletData6, _vm$walletData6$user;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "account-verification-page"
  }, [_c('wallet-header', {
    attrs: {
      "walletData": _vm.walletData,
      "isLoading": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "action-button",
      fn: function () {
        return [_c('span')];
      },
      proxy: true
    }])
  }), _vm.walletData && !_vm.isLoading ? _c('div', {
    staticClass: "verification-disclaimer-banner",
    class: {
      'rejected': ((_vm$walletData = _vm.walletData) === null || _vm$walletData === void 0 ? void 0 : (_vm$walletData$user = _vm$walletData.user) === null || _vm$walletData$user === void 0 ? void 0 : _vm$walletData$user.verificationStatus) === 'rejected',
      'pending': ((_vm$walletData2 = _vm.walletData) === null || _vm$walletData2 === void 0 ? void 0 : (_vm$walletData2$user = _vm$walletData2.user) === null || _vm$walletData2$user === void 0 ? void 0 : _vm$walletData2$user.verificationStatus) === 'pending'
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('i', {
    class: ((_vm$walletData3 = _vm.walletData) === null || _vm$walletData3 === void 0 ? void 0 : (_vm$walletData3$user = _vm$walletData3.user) === null || _vm$walletData3$user === void 0 ? void 0 : _vm$walletData3$user.verificationStatus) === 'rejected' ? 'bi bi-exclamation-triangle-fill' : 'bi bi-info-circle-fill'
  }), ((_vm$walletData4 = _vm.walletData) === null || _vm$walletData4 === void 0 ? void 0 : (_vm$walletData4$user = _vm$walletData4.user) === null || _vm$walletData4$user === void 0 ? void 0 : _vm$walletData4$user.verificationStatus) === 'rejected' ? _c('span', [_vm._v(" Your previous verification was rejected. Please resubmit your documents to withdraw funds. ")]) : ((_vm$walletData5 = _vm.walletData) === null || _vm$walletData5 === void 0 ? void 0 : (_vm$walletData5$user = _vm$walletData5.user) === null || _vm$walletData5$user === void 0 ? void 0 : _vm$walletData5$user.verificationStatus) === 'pending' ? _c('span', [_vm._v(" Your verification documents are being reviewed. We'll notify you once the process is complete. ")]) : _c('span', [_vm._v(" Account verification is required before you can withdraw funds from your wallet. ")])])]) : _vm._e(), _c('div', {
    staticClass: "container"
  }, [_vm.isLoading ? _c('h5', [_vm._v("Loading...")]) : _vm.error ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : ((_vm$walletData6 = _vm.walletData) === null || _vm$walletData6 === void 0 ? void 0 : (_vm$walletData6$user = _vm$walletData6.user) === null || _vm$walletData6$user === void 0 ? void 0 : _vm$walletData6$user.verificationStatus) === 'pending' ? _c('div', {
    staticClass: "py-5"
  }, [_c('div', {
    staticClass: "verification-pending-card text-center"
  }, [_vm._m(0), _c('h2', [_vm._v("Verification In Progress")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" Your account verification is currently being reviewed. This process typically takes 1-3 business days. ")]), _c('p', {
    staticClass: "text-muted mb-4"
  }, [_vm._v(" We will notify you via email once your verification is complete. ")]), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/wallet');
      }
    }
  }, [_vm._v(" Back to Wallet ")])])]) : _c('div', {
    staticClass: "py-5"
  }, [_c('h2', [_vm._v("Account verification")]), _c('p', [_vm._v("Enter your details below to get your account verified")]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('verification-form', {
    attrs: {
      "formData": _vm.formData,
      "selectedCountry": _vm.selectedCountry,
      "nationalPhoneNumber": _vm.nationalPhoneNumber,
      "countries": _vm.countries,
      "errors": _vm.errors,
      "isPhoneValid": _vm.isPhoneValid,
      "phoneInputTouched": _vm.phoneInputTouched,
      "isPhoneOTPRequested": _vm.isPhoneOTPRequested,
      "isEmailOTPRequested": _vm.isEmailOTPRequested,
      "phoneOTPButtonText": _vm.phoneOTPButtonText,
      "emailOTPButtonText": _vm.emailOTPButtonText,
      "passportFileName": _vm.passportFileName,
      "binanceScreenshotFileNames": _vm.binanceScreenshotFileNames
    },
    on: {
      "update:binance_email": function ($event) {
        _vm.formData.binance_email = $event;
      },
      "update:wallet_address": function ($event) {
        _vm.formData.wallet_address = $event;
      },
      "update:terms_accepted": function ($event) {
        _vm.formData.terms_accepted = $event;
      },
      "update:phone_otp": function ($event) {
        _vm.formData.phone_otp = $event;
      },
      "update:email_otp": function ($event) {
        _vm.formData.email_otp = $event;
      },
      "country-changed": _vm.handleCountryChanged,
      "phone-input": _vm.handlePhoneInput,
      "request-phone-otp": _vm.requestPhoneOTP,
      "request-email-otp": _vm.requestEmailOTP,
      "passport-uploaded": _vm.handlePassportUpload,
      "binance-screenshots-uploaded": _vm.handleBinanceScreenshotsUpload,
      "remove-binance-file": _vm.removeBinanceFile
    }
  }), _c('div', {
    staticClass: "submit-wrapper"
  }, [_c('button', {
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitting
    }
  }, [_vm._v(" " + _vm._s(_vm.isSubmitting ? "Submitting..." : "Submit") + " ")])])], 1)])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pending-icon mb-4"
  }, [_c('i', {
    staticClass: "bi bi-hourglass-split"
  })]);
}]

export { render, staticRenderFns }